var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitbtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:send-28-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.79005 2.77319L24.86 12.8502C25.073 12.9519 25.2528 13.1118 25.3787 13.3114C25.5046 13.511 25.5714 13.7422 25.5714 13.9782C25.5714 14.2142 25.5046 14.4454 25.3787 14.645C25.2528 14.8446 25.073 15.0045 24.86 15.1062L3.79005 25.1832C3.57405 25.2866 3.33288 25.3259 3.09523 25.2962C2.85758 25.2665 2.63345 25.1692 2.44952 25.0158C2.26558 24.8625 2.12958 24.6595 2.0577 24.431C1.98582 24.2026 1.98108 23.9583 2.04405 23.7272L4.15205 15.9992C4.17785 15.9045 4.23096 15.8195 4.30476 15.7547C4.37856 15.69 4.46978 15.6484 4.56705 15.6352L14.777 14.2482C14.8197 14.2421 14.8601 14.2251 14.8943 14.1988C14.9284 14.1726 14.9552 14.1379 14.972 14.0982L14.99 14.0362C14.9979 13.9804 14.9867 13.9235 14.9582 13.8748C14.9297 13.8262 14.8856 13.7886 14.833 13.7682L14.778 13.7532L4.57805 12.3662C4.48096 12.3528 4.38996 12.3111 4.31635 12.2464C4.24275 12.1817 4.18978 12.0968 4.16405 12.0022L2.04405 4.23019C1.98082 3.99905 1.98537 3.75461 2.05714 3.52599C2.12892 3.29736 2.26489 3.09419 2.44888 2.94066C2.63286 2.78713 2.8571 2.68971 3.09488 2.66002C3.33266 2.63033 3.57396 2.66961 3.79005 2.77319Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitbtnIcon);
export default __webpack_public_path__ + "static/media/submitbtn-icon.2025ea2c06ac020da790016c4e8fae00.svg";
export { ForwardRef as ReactComponent };